import React from 'react';
import { PayloadStates } from '@lore/utils';
import classNames from 'classnames';
import Loader from '../../../components/Loader';
import EmptyState from '../../../@communityshare/ui/EmptyState';
import { FolderIcon } from '@heroicons/react/24/outline';
import LocationMap from './LocationMap';
import Card from '../../../components/Card';
import SitesMap from './SitesMap';

export default function Results(props) {
  const { result, row } = props;

  if (result.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (result.data.length === 0) {
    return (
      <EmptyState
        icon={FolderIcon}
        title="There are currently no matching sites."
        subtitle="But check back later and there might be."
      />
    );
  }

  const mapKey = `${JSON.stringify(result.query)}:${result.meta.totalCount}`;

  return (
    <div key={mapKey} className={classNames(
      result._isPreviousData && 'opacity-50',
      'w-full grid grid-cols-1 gap-4'
    )}>
      <Card
        rounded={false}
        className={classNames(
          'rounded-cs-10',
          'p-4 space-y-3'
        )}
      >
        <div className="w-full h-[512px] opacity-70 rounded-cs-10 overflow-hidden">
          <SitesMap
            sites={result}
            cursor="arrow"
          />
        </div>
      </Card>
    </div>
  );
}
